import './couponSeed.scss';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Button, Input} from "antd";
import dayjs from "dayjs";
import {CSVLink} from "react-csv";
import TablePage from "../../../pages/tablePage/TablePage";
import GoToUserInfoButton from "../../../shared/components/buttons/GoToUserInfoButton";
import {CouponSeedEntity} from "../CouponSeedEntity";

const CouponSeed = () => {
    const [master, setMaster] = useState('');
    const [url, setUrl] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [rows, setRows] = useState([]);
    const [couponInfo, setCouponInfo] = useState(null);
    const refreshRef = useRef(null);

    const handleSearch = () => {
        setUrl(`coupon/coupon_seed?master=${master}`);
        setShowTable(true);
    }

    const handleSetMaster = (e) => {
        setMaster(e.target.value);
    }

    const handleDownload = () => {
        const data = rows.filter((row) => row.userKey === 0);
        return data.map((row) => {
            return {
                couponId: row.couponId,
            }
        });
    }

    useEffect(() => {
        if (refreshRef.current) {
            refreshRef.current();
        }
    }, [url]);

    const columns = useMemo(() => ([
        {
            title: '쿠폰 코드',
            dataIndex: 'couponId',
            key: 'couponId',
            search: true
        },
        {
            title: '쿠폰 이름',
            dataIndex: 'master',
        },
        {
            title: '사용 유저(PID)',
            dataIndex: 'pid',
            filters: [
                {text: '사용', value: 1},
                {text: '미사용', value: 0}
            ],
            onFilter: (value, record) => {
                if (value === 1) {
                    return record.userKey > 0;
                } else {
                    return record.userKey === 0;
                }
            },
        },
        {
            title: '사용 일',
            dataIndex: 'usedTime',
            render: (usedTime) => usedTime !== 0 ? dayjs.unix(usedTime).format('YYYY-MM-DD HH:mm:ss') : '',
        },
        {
            title: '유저 가입일',
            dataIndex: 'userCreated',
            render: (userCreated) => userCreated ? dayjs.unix(userCreated).format('YYYY-MM-DD HH:mm:ss') : '',
            sorter: (a, b) => (a.userCreated || 0) - (b.userCreated || 0),
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid} />,
        },
    ]), [rows]);

    // 개별 쿠폰(type=1)만 코드를 직접 추가할 수 있다. 공용 쿠폰은 코드가 하나뿐이라 CSV 추가 대상이 아니다.
    const isIndividual = couponInfo?.type === 1;

    const props = {
        columns,
        refreshRef,
        url,
        setRows,
        setTblData: setCouponInfo,
        ...(isIndividual && {
            csvUpload: url,
            csvIdentityKey: 'couponId',
            csvDeleteMissing: false,
            entityModel: CouponSeedEntity,
            csvColumns: [{key: 'couponId', desc: '쿠폰 코드 (영문/숫자 20자 이내, 소문자는 대문자로 변환됩니다)'}],
            csvTemplateName: 'coupon_seed_form.csv',
            csvPageDownload: false,
            csvModalWidth: 900,
            csvGuide: [
                '인코딩 : UTF-8(BOM 포함) / 구분자 : 쉼표(,)',
                `현재 조회 중인 쿠폰(${master}) 에 코드가 추가됩니다.`,
                '이미 등록된 코드는 사용 이력이 유지되도록 건너뜁니다. (덮어쓰기/삭제 없음)',
                '[CSV 양식 다운로드] 로 빈 양식을 받아 couponId 열에 코드를 한 줄씩 적어주세요. 2번째 # 행은 설명이며 업로드 시 무시됩니다.',
            ],
        })
    }

    return (
        <div className={"coupon-seed-main"}>
            <div className="coupon-seed-search">
                <Input
                    name="value"
                    size="small"
                    value={master}
                    onChange={handleSetMaster}
                    placeholder="Search by master"
                    style={{ width: 200, marginRight: 8 }}
                />
                <Button
                    variant="contained"
                    size="small"
                    onClick={handleSearch}
                >
                    Search
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    disabled={rows.length === 0}
                >
                    <CSVLink data={handleDownload()} filename={`${master}_coupon_seed_${dayjs().format('YYYYMMDDHHmmss')}.csv`}>Download CSV</CSVLink>
                </Button>
            </div>

            {showTable && (
                <TablePage {...props}/>
            )}
        </div>
    );
};

export default CouponSeed;